import { getSupabase } from "../../lib/supabase";
import { clearCachedSubscription } from "../../lib/webPush";

export type OAuthProvider = "google" | "apple";

export async function signIn(email: string, password: string): Promise<void> {
  const { error } = await getSupabase().auth.signInWithPassword({ email, password });
  if (error) throw error;
}

// `confirmation_required` carries the email so the caller doesn't have to
// re-track it. Prefer the server-recorded address (data.user.email) over
// the form value — the verification mail is sent to whatever Supabase
// recorded — and fall back to the submitted email if the SDK omits it.
export type SignUpResult =
  | { status: "session_established" }
  | { status: "confirmation_required"; email: string };

export async function signUp(email: string, password: string): Promise<SignUpResult> {
  const { data, error } = await getSupabase().auth.signUp({ email, password });
  if (error) throw error;
  if (data.session !== null) return { status: "session_established" };
  return { status: "confirmation_required", email: data.user?.email ?? email };
}

export async function signInWithOAuth(provider: OAuthProvider): Promise<void> {
  const { error } = await getSupabase().auth.signInWithOAuth({
    provider,
    options: { redirectTo: `${window.location.origin}/auth/callback` },
  });
  if (error) throw error;
}

export async function signOut(): Promise<void> {
  const { error } = await getSupabase().auth.signOut();
  if (error) throw error;
  await clearCachedSubscription();
}
